import Sidebar from "component/Sidebar"
import Header from "component/Header"
import OrderHistoryTable from "./OrderHistoryTable"


const OrderHistoryManage = () => (
    <>
        <Header root={true} />
        <div className="min-h-screen bg-gray-100 flex flex-col lg:flex-row">
            <Sidebar />
            <div className="flex-1 p-4 md:p-8">
                {/* <TopBar /> */}
                <div className="w-full h-full bg-gray-200 border-dashed border-4 border-gray-300">
                    <OrderHistoryTable />
                </div>
            </div>
        </div>
    </>
)

export default OrderHistoryManage